package com.ervasstudio.tracoemovimento.util

fun mapFirebaseError(code: String?): String = when (code) {
    "auth/popup-closed-by-user" -> "Login cancelado."
    "auth/cancelled-popup-request" -> "Já havia um pedido de login em curso, tenta novamente."
    "auth/popup-blocked" -> "O browser bloqueou a janela de login. Permite pop-ups para este site."
    "auth/network-request-failed" -> "Falha de rede. Verifica a tua ligação."
    "auth/account-exists-with-different-credential" -> "Já existe uma conta com este email usando outro método de login."
    "auth/too-many-requests" -> "Muitas tentativas. Tenta novamente mais tarde."
    else -> "Não foi possível iniciar sessão. Tenta novamente."
}